// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBlock_search__pyqz_","title":"SearchBlock_title__lDxZP","chineseTitle":"SearchBlock_chineseTitle__B0h1r"};